<template>
  <div class="no-auth">
    <img src="@/assets/image/auth.svg" alt="" />
    <div class="inputContainer">
      <input v-model.trim="pwd" placeholder="请输入密码" type="password" />
    </div>
    <van-button @click="checkPwd" round type="info" block>确定</van-button>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {vertifyAuth, vertifyAuthInResource} from '@/api'
export default {
  name: 'validPwd',
  data() {
    return {
      pwd: '',
      id: this.$route.params.id,
      type: this.$route.query.type // 2-资源 1-活动
    }
  },
  methods: {
    checkPwd() {
      if (!this.pwd) return this.$Toast.fail('请输入密码')
      if (this.type === '2') {
        const params = {
          password: this.pwd,
          resourceId: this.id
        }
        vertifyAuthInResource(params).then(res => {
          const {auth} = res.data
          if (auth) {
            this.$router.replace(`/resourcePlay/${this.id}?pass=true`)
          } else {
            this.$Toast.fail('密码错误')
          }
        })
        return
      }
      vertifyAuth(this.id, this.pwd).then(res => {
        const {auth} = res.data
        if (auth) {
          this.$router.replace(`/play/${this.id}?pass=true`)
        } else {
          this.$Toast.fail('密码错误')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.no-auth {
  height: 100vh;
  padding: 20px;
  padding-top: 80px;
  text-align: center;
  img {
    width: 200px;
  }
}
div.inputContainer {
  height: 46px;
  border-radius: 47px;
  margin-bottom: 40px;
  margin-top: 40px;
  overflow: hidden;
  background: #f7f7f7;
  input {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
    padding: 0 20px;
    background: rgba(240, 240, 240, 1);
    &::-webkit-input-placeholder {
      color: #c0c4cc;
      background: rgba(240, 240, 240, 1);
    }
  }
}
</style>
